import classNames from "classnames";
import styles from "./SuspenseFallback.module.css";

//#region [Props]
type SuspenseFallbackProps = {
    theme?: "dark" | "light";
}
//#endregion

//#region [Component]
export default function SuspenseFallback({ theme = "dark" }: SuspenseFallbackProps) {
    return <div className={classNames(styles[theme], styles.loader)}></div>;
}
//#endregion

//#region [Styles]

//#endregion